import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { Box } from './Box';
import { Flex } from './Flex';

const Footer = styled(Flex)
    .withConfig({ displayName: 'Footer' })
    .attrs((props) => ({
        ...props,
        as: 'footer',
        width: '100%',
        direction: 'row',
        spacing: 2,
        px: 2,
        py: 1.5,
        transition: 'transform 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
        borderTopLeftRadius: { sm: 2 },
        borderTopRightRadius: { sm: 2 },
        background: 'rgba(0, 0, 0, 0.65)',
        backdropFilter: 'blur(20px)',
    }))``;

interface StickyFooterProps extends ComponentProps<typeof Flex> {}

export const StickyFooter = (props: StickyFooterProps) => {
    const { children, ...other } = props;

    return (
        <Box
            position="sticky"
            width="100%"
            bottom="var(--safe-area-inset-bottom)"
            height="1px"
            mt="auto"
        >
            <Footer {...other}>{children}</Footer>
        </Box>
    );
};
